'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _episodes = require('./episodes.component');

var _episodes2 = _interopRequireDefault(_episodes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var episodesModule = _angular2.default.module('episodes', [_angularUiRouter2.default]).component('episodes', _episodes2.default);

exports.default = episodesModule;


// WEBPACK FOOTER //
// ./client/app/common/admin/episodes/episodes.js